//
//
//
//
//
//
//
//
//
//
//

export default {
    name: 'CourierNav',
    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        headUrl: {
            type: String,
            default: require('~/assets/images/head.png')
        },
        activeId: String,
        unreadCount: {
            type: String,
            default: '0'
        }
    },
    methods: {
        choseNav() {
            if (this.id !== this.activeId) {
                this.$emit('choseNav', this.id)
            }
        },
        removeVisitor() {
            this.$emit('removeVisitor', this.id)
        }
    }
}
